import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dc05098"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "detailMessage",
  tabindex: "-1",
  "aria-labelledby": "detailMessage",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "m-lg-4 m-0 mb-4" }
const _hoisted_7 = { class: "d-flex mb-2 mb-lg-0 flex-lg-row flex-column justify-content-between align-items-lg-center align-items-start" }
const _hoisted_8 = { class: "d-flex align-items-center position-relative" }
const _hoisted_9 = { class: "fs-7 d-flex justify-content-end" }
const _hoisted_10 = { class: "mt-2 fw-bold text-break break-spaces" }
const _hoisted_11 = { class: "text-break break-spaces mx-lg-4 mx-0 mb-5 border-top pt-4" }
const _hoisted_12 = { class: "d-flex justify-content-center" }

import { PropType, computed, watchEffect, ComputedRef } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import dayjs from 'dayjs'
import Title from '@/components/title/index.vue'
import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import { CONVERSATIONS_STORE, COMMUNITY_STORE } from '@/store/constants'
import { CommunityStateTypes } from '@/store/modules/community'
import { ReplaceHashtag } from '@/constants/common'
import { getFileNameFromUrl } from '@/constants/regex'
import TargetTag from '@/components/target-tag/index.vue'
import { blobDownload } from '@/utils'
import { usePath } from '@/use/usePath'

//TODO: SS30


export default /*#__PURE__*/_defineComponent({
  props: {
  messageData: {
    id: String | Number,
    tag: String,
    invitationGroup: Boolean,
  },
  messageTag: Function as PropType<() => void | undefined>,
},
  setup(__props) {

const props = __props

const route = useRoute()
const router = useRouter()
const store = useStore()



const messageDetail = computed(() => store.getters[CONVERSATIONS_STORE.GETTERS.MESSAGE_DETAIL])
const profile = computed<ComputedRef<Pick<CommunityStateTypes, 'me'>>>(() => store.getters[COMMUNITY_STORE.GETTERS.GET_ME]?.profile)

const { path } = usePath()
const clickFile = async (fileUrl: string) => {
  // eslint-disable-next-line prettier/prettier
  const requestParams = ['request_path=' + path, 'community_id=' + route.params?.id, 'type=' + props.messageTag(messageDetail.value?.message_tag)?.fileType]

  const blob = await fetch(fileUrl + '?' + requestParams.join('&'), { credentials: 'include' }).then((r) => r.blob())
  const fileName = getFileNameFromUrl(fileUrl)
  blobDownload(blob, fileName)
}

watchEffect(() => {
  if (props.messageData?.id && props.messageData?.tag) {
    store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_MESSAGE_DETAIL, {
      community_id: router.currentRoute.value?.params?.id,
      id: props.messageData?.id,
      tag: props.messageData?.tag,
      invitationGroup: props.messageData?.invitationGroup,
    })
  }
})

return (_ctx: any,_cache: any) => {
  const _component_h7 = _resolveComponent("h7")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(Title, {
            title: _unref(translate)('message'),
            className: 'fw-bolder'
          }, null, 8, ["title"]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(UserAliasIcon, {
                  userType: __props.messageTag(_unref(messageDetail)?.message_tag)?.type
                }, null, 8, ["userType"]),
                _createVNode(_component_h7, {
                  class: _normalizeClass(['fw-bold text-break break-spaces', _unref(messageDetail)?.message_tag === 'yelloop' ? 'subject-yelloop' : 'text-black'])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(messageDetail)?.message_tag === 'community' ? _unref(messageDetail)?.operating_name : __props.messageTag(_unref(messageDetail)?.message_tag)?.name), 1)
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(dayjs)(_unref(messageDetail)?.booking_date).format('YYYY/MM/DD HH:mm')), 1)
            ]),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(messageDetail)?.subject), 1)
          ]),
          _createVNode(TargetTag, {
            data: _unref(ReplaceHashtag)(_unref(profile)?.family_name, _unref(profile)?.given_name, _unref(messageDetail)?.content),
            className: 'mx-lg-4 mx-0 mb-5 border-top pt-4 '
          }, null, 8, ["data"]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", null, [
              (_unref(messageDetail)?.file_url_1)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (clickFile(_unref(messageDetail)?.file_url_1))),
                    href: "javascript:void(0)"
                  }, _toDisplayString(_unref(getFileNameFromUrl)(_unref(messageDetail)?.file_url_1)), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              (_unref(messageDetail)?.file_url_2)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (clickFile(_unref(messageDetail)?.file_url_2))),
                    href: "javascript:void(0)"
                  }, _toDisplayString(_unref(getFileNameFromUrl)(_unref(messageDetail)?.file_url_2)), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              (_unref(messageDetail)?.file_url_3)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (clickFile(_unref(messageDetail)?.file_url_3))),
                    href: "javascript:void(0)"
                  }, _toDisplayString(_unref(getFileNameFromUrl)(_unref(messageDetail)?.file_url_3)), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal"
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ]))
}
}

})